import React from 'react';
import { Box, Typography, Container, Grid, Card, CardContent } from '@mui/material';
import { styled } from '@mui/material/styles';

const ServicesContainer = styled(Box)(({ theme }) => ({
  padding: '6rem 0',
  backgroundColor: 'white',
  position: 'relative'
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: '3rem',
  fontWeight: 700,
  textAlign: 'center',
  marginBottom: '1rem',
  color: '#1e293b',
  [theme.breakpoints.down('md')]: {
    fontSize: '2.5rem'
  }
}));

const SectionSubtitle = styled(Typography)(({ theme }) => ({
  fontSize: '1.25rem',
  textAlign: 'center',
  marginBottom: '4rem',
  color: '#64748b',
  maxWidth: '600px',
  margin: '0 auto 4rem auto'
}));

const ServiceCard = styled(Card)(({ theme }) => ({
  height: '100%',
  borderRadius: '20px',
  boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
  transition: 'all 0.4s ease',
  border: '1px solid #e2e8f0',
  overflow: 'hidden',
  '&:hover': {
    transform: 'translateY(-12px)',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
    '& .service-icon': {
      transform: 'scale(1.1)',
      backgroundColor: '#1e40af'
    }
  }
}));

const ServiceIcon = styled(Box)(({ theme }) => ({
  width: '80px',
  height: '80px',
  borderRadius: '20px',
  backgroundColor: '#3b82f6',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: '2rem',
  fontSize: '2rem',
  color: 'white',
  transition: 'all 0.3s ease',
  boxShadow: '0 8px 16px rgba(59, 130, 246, 0.3)'
}));

const ServiceTitle = styled(Typography)(({ theme }) => ({
  fontSize: '1.5rem',
  fontWeight: 600,
  marginBottom: '1rem',
  color: '#1e293b'
}));

const ServiceDescription = styled(Typography)(({ theme }) => ({
  fontSize: '1rem',
  color: '#64748b',
  lineHeight: 1.7
}));

const getServiceIcon = (iconName) => {
  const iconMap = {
    'Users': '👥',
    'Target': '🎯',
    'Zap': '⚡',
    'Shield': '🛡️'
  };
  return iconMap[iconName] || '🔧';
};

const ServicesSection = ({ services }) => {
  const defaultServices = [
    {
      title: 'Consulting Services',
      description: 'Expert guidance and strategic planning to help your business grow and succeed in competitive markets.',
      icon: 'Users'
    },
    {
      title: 'Digital Marketing',
      description: 'Comprehensive digital marketing solutions including SEO, social media, and content marketing strategies.',
      icon: 'Target'
    },
    {
      title: 'Technology Solutions',
      description: 'Cutting-edge technology implementations and custom software development for modern businesses.',
      icon: 'Zap'
    },
    {
      title: 'Security Services',
      description: 'Advanced cybersecurity solutions to protect your business data and maintain customer trust.',
      icon: 'Shield'
    }
  ];

  const displayServices = services || defaultServices;

  return (
    <ServicesContainer>
      <Container maxWidth="lg">
        <SectionTitle variant="h2">
          Our Services
        </SectionTitle>
        <SectionSubtitle variant="body1">
          We provide comprehensive solutions tailored to meet your business needs
        </SectionSubtitle>
        <Grid container spacing={4}>
          {displayServices.map((service, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <ServiceCard>
                <CardContent sx={{ padding: '2.5rem', textAlign: 'center' }}>
                  <ServiceIcon className="service-icon">
                    {getServiceIcon(service.icon)}
                  </ServiceIcon>
                  <ServiceTitle variant="h6">
                    {service.title}
                  </ServiceTitle>
                  <ServiceDescription variant="body2">
                    {service.description}
                  </ServiceDescription>
                </CardContent>
              </ServiceCard>
            </Grid>
          ))}
        </Grid>
      </Container>
    </ServicesContainer>
  );
};

export default ServicesSection;
